import { render, staticRenderFns } from "./FilesAppSettingsLegacyApi.vue?vue&type=template&id=1981647c"
import script from "./FilesAppSettingsLegacyApi.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettingsLegacyApi.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports